import { Divider } from 'antd'
// styles
import styles from '../../../styles.module.scss'
import toNumber from 'lodash/toNumber'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

interface TransactionRecordInterface {
  date?: string
  points?: string
  type?: string
  description?: string
}

const Component: React.FC<TransactionRecordInterface> = ({
  date,
  points,
  type,
  description = ""
}) => {
  const { t } = useTranslation()
  const total = toNumber(points)
  const dateFormat = dayjs(date).locale('es').format('DD MMM')

  return (
    <div className={styles.transactionRecord}>
      <div>
        <span className="date">{dateFormat}</span>
        <Divider type="vertical" />
        <span className="description">
          {type !== "cash_out" || !description ? t([`TRANSACTION_${type}`, 'TRANSACTION_other']) : description}
        </span>
      </div>
      <span className="points">
        {total} Punto{total > 1 ? 's' : ''}
      </span>
    </div>
  )
}

export default Component
